export default () => {
    class CustomMarker extends google.maps.OverlayView {

        constructor(coords, classname) {
            super();
            this.coords = coords;
            this.node = document.createElement("div");
            if (classname) {
                this.node.classList.add(classname);
            }
            this.node.style.position = "absolute";
            this.node.style.width = 0;
            this.node.style.height = 0;
        }

        onAdd() {
            this.getPanes().overlayMouseTarget.appendChild(this.node);
        }

        draw() {
            const overlayProjection = this.getProjection();
            const point = overlayProjection.fromLatLngToDivPixel(this.coords);
            if (point) {
                this.node.style.left = point.x + 'px';
                this.node.style.top = point.y + 'px';
            }
        }

        onRemove() {
            if (this.node) {
                this.node.parentNode.removeChild(this.node);
                this.node = null;
            }
        }

        clearFromMap() {
            this.setMap(null);
        }
    }

    return CustomMarker;
}
